import { getTermValue, TJsonQuery } from '../../../../packages/JsonQuery';
import { ESortValue } from '../../../../packages/api-models/common/json_query';
import { IApplicationState } from '../../types/redux';
import { fromESortValue, TSortKey } from '../../utils/sort/sortMapping';

export function selectActiveSortKey(state: IApplicationState): TSortKey {
  const sortValue = getTermValue('sort')(state.filters.jsonQuery as TJsonQuery);

  return fromESortValue(sortValue ?? ESortValue.Default);
}
